import React from 'react';
import PropTypes from 'prop-types';
import RatingAndReviews from 'components/consumer/RatingAndReviews';
import useModularPDPCustomerPhotosAndReviews from 'data-hooks/useModularPDPCustomerPhotosAndReviews';
import getRoundedRating from 'commons/getRoundedRating';

const ModularPDPRatingAndReviews = ({ onClick, href }) => {
  const modularCustomerReviewsData = useModularPDPCustomerPhotosAndReviews();

  const {
    loading,
    customer_photos_min: { totalPhotos } = {},
    customer_reviews: { totalReviews, averageRating } = {},
  } = modularCustomerReviewsData || {};

  const roundedRating = getRoundedRating(averageRating);

  return (
    <RatingAndReviews
      loading={loading}
      rating={roundedRating}
      numberOfReviews={(totalPhotos || 0) + (totalReviews || 0)}
      onClick={onClick}
      href={href}
    />
  );
};

ModularPDPRatingAndReviews.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string,
};

export default ModularPDPRatingAndReviews;
